import React, { Fragment } from "react"

import KnowledgeListItem from "../../../common/knowledge-list/KnowledgeListItem"
import KnowledgeListItemShadow from "../../../common/knowledge-list/KnowledgeListItemShadow"
import KnowledgeLinkButton from "../../../common/knowledge-list/KnowledgeLinkButton"
import expandableItem from "../../../common/ExpandableItem"
import WidgetHeaderButton from "../../../common/WidgetHeaderButton"

import SearchBar from "../../../common/SearchBar"

const ExpandableKnowledgeListItem = expandableItem(
    ({ toggleExpansion, ...article }) => (
        <KnowledgeListItem
            onClick={() => toggleExpansion}
            toggleExpansion={toggleExpansion}
            expansionLinkComponent={({ id, link }) => (
                <Fragment>
                    <KnowledgeLinkButton
                        link={`/knowledge/${id}`}
                        text="Edit article in Dashboard"
                    />
                    <KnowledgeLinkButton link={link} />
                </Fragment>
            )}
            {...article}
        />
    )
)

const ClusterEditItemArticles = ({
    articles,
    otherArticlesSearchTerm,
    otherArticlesSearch,
    isFetchingOtherArticlesSearch,
    headlineArticleSearchTerm,
    headlineArticleSearch,
    isFetchingHeadlineArticleSearch,
    onSearch,
    onArticleSelect,
    onApply
}) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            Headline article{" "}
            {(articles || []).filter(({ is_headline }) => is_headline).length <=
                0 && <span style={{ color: "red" }}>*</span>}
            {headlineArticleSearchTerm && (
                <div className="pull-right">
                    <WidgetHeaderButton
                        onClick={() => onApply("headlineArticle")}
                    >
                        Apply
                    </WidgetHeaderButton>
                </div>
            )}
        </h3>
        <p>
            Changing the headline article will <strong>automatically</strong>{" "}
            change the <strong>title</strong> (which can be edited afterwards)
            and the <strong>image</strong> of the cluster.
        </p>
        <div className="search-bar-container">
            <SearchBar
                searchTerm={headlineArticleSearchTerm}
                name="headlineArticle"
                placeholder="search to change headline article"
                onSearch={onSearch}
            />
        </div>
        <div
            className="widget-content list-group items-list cluster-related-items-list"
            style={{ marginBottom: "20px" }}
        >
            {isFetchingHeadlineArticleSearch ? (
                [0, 1, 2].map(index => <KnowledgeListItemShadow key={index} />)
            ) : (
                <Fragment>
                    {headlineArticleSearchTerm &&
                        headlineArticleSearch.map(article => (
                            <KnowledgeListItem
                                key={article.id}
                                showApproved={true}
                                {...article}
                                // Override the language here to not have too many icons on the item
                                language={null}
                                showCheckbox={true}
                                onClick={() => () =>
                                    onArticleSelect("headlineArticle", article)}
                                isChecked={article.isAdded}
                            />
                        ))}
                    {(articles || [])
                        .filter(({ is_headline }) => is_headline)
                        .map(article => (
                            <ExpandableKnowledgeListItem
                                key={article.id}
                                showApproved={true}
                                {...article}
                                language={null}
                            />
                        ))}
                    {((headlineArticleSearchTerm &&
                        (!headlineArticleSearch ||
                            !headlineArticleSearch.length)) ||
                        !articles ||
                        !articles.length) && <p>No articles</p>}
                </Fragment>
            )}
        </div>
        <h3 className="widget-header">
            <span className="icon icon-insights" />
            Other articles{" "}
            {(articles || []).filter(({ is_headline }) => !is_headline)
                .length <= 0 && <span style={{ color: "red" }}>*</span>}
            {otherArticlesSearchTerm && (
                <div className="pull-right">
                    <WidgetHeaderButton
                        onClick={() => onApply("otherArticles")}
                    >
                        Apply
                    </WidgetHeaderButton>
                </div>
            )}
        </h3>
        <div className="search-bar-container">
            <SearchBar
                searchTerm={otherArticlesSearchTerm}
                name="otherArticles"
                placeholder="search to add other articles"
                onSearch={onSearch}
            />
        </div>
        <div className="widget-content list-group items-list cluster-related-items-list">
            {isFetchingOtherArticlesSearch ? (
                [0, 1, 2].map(index => <KnowledgeListItemShadow key={index} />)
            ) : (
                <Fragment>
                    {otherArticlesSearchTerm &&
                        otherArticlesSearch.map(article => (
                            <KnowledgeListItem
                                key={article.id}
                                showApproved={true}
                                {...article}
                                // Override the language here to not have too many icons on the item
                                language={null}
                                showCheckbox={true}
                                onClick={() => () =>
                                    onArticleSelect("otherArticles", article)}
                                isChecked={article.isAdded}
                            />
                        ))}
                    {((!otherArticlesSearchTerm && articles) || [])
                        .filter(({ is_headline }) => !is_headline)
                        .map(article => (
                            <ExpandableKnowledgeListItem
                                key={article.id}
                                showApproved={true}
                                {...article}
                                // Override the language here to not have too many icons on the item
                                language={null}
                                allowRemove={true}
                                onRemoveClick={() => event => {
                                    event.stopPropagation()
                                    event.preventDefault()
                                    onArticleSelect("otherArticles", article)
                                }}
                            />
                        ))}
                    {((otherArticlesSearchTerm &&
                        (!otherArticlesSearch ||
                            !otherArticlesSearch.length)) ||
                        !articles ||
                        !articles.length) && <p>No articles</p>}
                </Fragment>
            )}
        </div>
    </div>
)

export default ClusterEditItemArticles
